import ButtonSkeleton from '../../../../../../components/Button/skeleton';
import QuestionOptionSkeleton from './QuestionOption/skeleton';
import { Root, unpublishedQuestionOptionsClasses } from './styles';

export interface UnpublishedQuestionOptionsSkelrtonProps {
  className?: string;
}

const UnpublishedQuestionOptionsSkeleton = ({ className }: UnpublishedQuestionOptionsSkelrtonProps) => {
  return (
    <Root className={className}>
      <QuestionOptionSkeleton className={unpublishedQuestionOptionsClasses.questionOption} />
      <QuestionOptionSkeleton className={unpublishedQuestionOptionsClasses.questionOption} />
      <ButtonSkeleton fullWidth className={unpublishedQuestionOptionsClasses.addAnotherOptionButton} />
    </Root>
  );
};

export default UnpublishedQuestionOptionsSkeleton;
